import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { LayoutModule } from "../../../layouts/layout.module";
import { DefaultComponent } from "../default.component";
import { DashboardComponent } from "./dashboard.component";
import { appService } from "../../../../../app/_services/app.service";
import { CommonService } from "../../../../../app/_services/common.service";
// import { ChartsModule } from '../../../../../../node_modules/ng2-charts';
import { ChartsModule } from "../../../../../../node_modules/ng2-charts";
import { SharedModule } from "../../../../../app/freightconfirmation/app.sharemodule";

import { ChartModule } from "primeng/chart";
import { ProgressBarModule } from "primeng/progressbar";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { NgCircleProgressModule } from "ng-circle-progress";
import { ProgressbarModule } from "ngx-bootstrap";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../../home/translateConfig.service";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

const routes: Routes = [
  {
    path: "",
    component: DefaultComponent,
    children: [
      {
        path: "",
        component: DashboardComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    ProgressBarModule,
    ScrollPanelModule,
    ProgressbarModule.forRoot(),
    RouterModule.forChild(routes),
    LayoutModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ChartsModule,
    SharedModule,
    ChartModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }),
  ],
  exports: [RouterModule],
  declarations: [DashboardComponent],
  providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class DashboardModule {}
